
import { Location } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { ApiGateway, PageOptions, TypeHospitalization } from 'cw-backend';
import { CwUtils } from 'cw-utils';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class TypeHospitalizationListProvider implements Resolve<any> {
    typeHospitalization: TypeHospitalization[];
    typeHospitalizationEdit: TypeHospitalization;
    onDataChanged: BehaviorSubject<any>;
    routeParams: any;
    state: any;
    pageOptions: PageOptions;
    currentPage: PageOptions;

    constructor(
        public gw: ApiGateway,
        private location: Location,
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        // Get state for current or new page
        this.state = this.location.getState();
        this.currentPage = this.state?.currentPage;
        this.typeHospitalizationEdit = this.state?.currentTypeHospitalization;

        if (this.currentPage) {
            this.pageOptions = this.currentPage;
        }
        else {
            this.pageOptions = new PageOptions();
            this.pageOptions.fieldSort = 'code';
        }
        return new Promise<void>((resolve, reject) => {
            Promise.all([
                this.getPage(this.pageOptions)
            ]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    get(id: number): Observable<TypeHospitalization> {
        if (!id) {
            return null;
        }
        return this.gw.get('typeHospitalization/:id', { id: id });
    }

    get currentTypeHospitalization(): TypeHospitalization {
        return this.typeHospitalizationEdit;
    }

    getAll(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get('typeHospitalization/').subscribe((res: HttpResponse<any>) => {
                this.typeHospitalization = res.body;
                resolve(res);
            }, reject);
        });

    }

    getPage(pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('typeHospitalization/search', pageOptions).subscribe((res: HttpResponse<any>) => {
                if (!CwUtils.compare(this.typeHospitalization, res.body.content) && res.body.content.length > 0) {
                    this.typeHospitalization = res.body.content;
                    this.onDataChanged.next(this.typeHospitalization);
                }
                else {
                    this.typeHospitalization = res.body.content;
                };
                resolve(res);
            }, reject);
        });
    }

    getPageSettings() {
        if (this.currentPage) {
            return this.pageOptions;
        } else {
            return;
        }
    }
}

